import { MataPelajaranRepositoryInterface } from '../../../data/contracts/MataPelajaran';
import { MataPelajaranDataMapper } from '../../../data/mappers/MataPelajaran';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { MataPelajaran } from '../../../entities/MataPelajaran';

export class MataPelajaranApiRepository implements MataPelajaranRepositoryInterface {
  private apiService: ApiService;
  private mapper: MataPelajaranDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: MataPelajaranDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllMataPelajaran(jenjang: string): Promise<MataPelajaran[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.mataPelajaran(),
      { jenjang: jenjang },
      null,
      headers
    );
    return this.mapper.convertMataPelajaranDataFromApi(dataResponse);
  }
}
